import React from "react";
export interface FeatureFlagContextValue {
  features: {
    id: string;
    identifier: string;
  }[];
}
export const FeatureFlagContext = React.createContext<FeatureFlagContextValue>({
  features: []
});